'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'stroopwafel';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f551';
var svgPathData = 'M256 16a240 240 0 1 0 0 480 240 240 0 1 0 0-480zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM131.5 120.2l56.6 56.6 56.6-56.6-33.9-33.9-5.7-5.7 11.3-11.3 5.7 5.7 33.9 33.9 33.9-33.9 5.7-5.7 11.3 11.3-5.7 5.7-33.9 33.9 56.6 56.6 56.6-56.6 5.7-5.7 11.3 11.3-5.7 5.7-56.6 56.6 56.6 56.6 33.9-33.9 5.7-5.7 11.3 11.3-5.7 5.7-33.9 33.9 39.6 39.6-11.3 11.3-5.7-5.7-33.9-33.9-56.6 56.6 56.6 56.6 5.7 5.7-11.3 11.3-5.7-5.7-56.6-56.6-56.6 56.6 33.9 33.9 5.7 5.7-11.3 11.3-39.6-39.6-33.9 33.9-5.7 5.7-11.3-11.3 5.7-5.7 33.9-33.9-56.6-56.6-56.6 56.6-5.7 5.7-11.3-11.3 5.7-5.7 56.6-56.6-56.6-56.6-33.9 33.9-5.7 5.7-11.3-11.3 5.7-5.7 33.9-33.9-33.9-33.9-5.7-5.7 11.3-11.3 5.7 5.7 33.9 33.9 56.6-56.6-56.6-56.6-5.7-5.7 11.3-11.3 5.7 5.7zm0 135.8l56.6 56.6 56.6-56.6-56.6-56.6-56.6 56.6zm67.9 67.9l56.6 56.6 56.6-56.6-56.6-56.6-56.6 56.6zm181-67.9l-56.6-56.6-56.6 56.6 56.6 56.6 56.6-56.6zM256 244.7l56.6-56.6-56.6-56.6-56.6 56.6 56.6 56.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStroopwafel = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;